var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"none"},attrs:{"src":("https://view.officeapps.live.com/op/embed.aspx?src=" + _vm.value),"width":"100%","height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }